import { render, staticRenderFns } from "./scheme-advantages-IndustrialManufacturingSolutions.vue?vue&type=template&id=7af9ac28&scoped=true"
import script from "./scheme-advantages-IndustrialManufacturingSolutions.vue?vue&type=script&lang=js"
export * from "./scheme-advantages-IndustrialManufacturingSolutions.vue?vue&type=script&lang=js"
import style0 from "./scheme-advantages-IndustrialManufacturingSolutions.vue?vue&type=style&index=0&id=7af9ac28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af9ac28",
  null
  
)

export default component.exports